// extracted by mini-css-extract-plugin
module.exports = {"deltaPros":"howPrepares_deltaPros__3DBEk"};